export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";